import { Button } from "@/components/ui/button";
import FormBox from "@/features/shared/components/FormBox";
import React, { useState } from "react";
import TextInputElement from "../../../../components/input/v1/TextInputElement";

interface Props {
    onSubmit: (inputData: { [key: string]: string }) => void;
    onResendCodeClick: () => void,
}

const ForgotPasswordInsertCodeBox: React.FC<Props> = ({
    onSubmit,
    onResendCodeClick,
}) => {

    const [inputs, setInputs] = useState<{ [key: string]: string }>({
        code: '',
    });

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;

        setInputs((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault()
        onSubmit(inputs);
    }

    // ********************************************************************************
    return (
        <FormBox
            title="Inserisci codice"
            description="Hai ricevuto per e-mail un codice a 6 cifre per verificare il tuo indirizzo e-mail. Inseriscilo qui per reimpostare una nuova password."
            formContent={
                <>
                    <TextInputElement
                        name="code"
                        label="Codice recupero password"
                        placeholder="000000"
                        errorText={""}
                        inputValue={inputs.code}
                        onChange={handleInputChange}
                    />
                    <Button
                        size={'form'}
                        disabled={!(inputs.code.length === 6)}
                    >
                        Conferma codice
                    </Button>
                </>
            }
            actionButton={
                <Button variant={'white'} size={'form'} onClick={onResendCodeClick}>
                    Invia nuovo codice
                </Button>
            }
            onSubmit={handleSubmit}
        />
    )
}

export default ForgotPasswordInsertCodeBox
